import { render } from "./MainPage.vue?vue&type=template&id=2c19cc9f&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=2c19cc9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c19cc9f"]])

export default __exports__